import React, { useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import useAuthorization from "../../hooks/useAuthorization";

export const PublicRoute = ({ component: Component, title, ...rest }) => {
  const { validateToken } = useAuthorization();
  const token = localStorage.getItem("token");
  const isValid = validateToken(token);

  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);
  
  return (
    <Route
      {...rest}
      render={(props) =>
        isValid ? <Redirect to="/dashboard" /> : 
        <div className={`main-div ${window.location.pathname === '/login' || window.location.pathname === '/change-password' || window.location.pathname === '/forgot-password' ? 'mobile-view-password-spacing' : undefined}`}>
          <Component {...props} />
        </div>
      }
    />
  );
};
